<template lang="pug">
.side-sheet(:class='state')
	swiper.swipers(
		:class='{ active : activeSlide > 0 }'
		:options='swiperConfig'
		:active-slide='activeSlide'
		@swiper='swiper = $event'
		@slide-change-transition-end='updateActiveSlide'
	)
		.empty(
			slot='slide-1'
			@click='close'
		)
		.page(
			slot='slide-2'
		)
			.header
				slot(name='title')
				.buttons-container(v-if="!confirm")
					a.icon-pencil(@click='edit')
					a.button.delete-button(@click="confirm = true") Delete
					.icon-close(@click='close')
				.buttons-container.right(v-else)
					p Confirm Delete?
					.confirm.right(@click='emitDelete')
						span.icon-check
					.cancel.right(@click='confirm = false')
						span.icon-close
			slot(name='side-sheet-content')
</template>

<script>
import Swiper from '@/components/Swiper';

export default {

	name : 'side-sheet',

	props : {
		side : {
			default : 'right',
			type    : String,
			validator( value ) {
				return value === 'left' || value === 'right';
			},
		},

		width : {
			default : 500,
			type    : Number,
		},

		state : {
			required : true,
			type     : String,
		},
	},

	data : () => ( {

		swiper : null, // null be default until the component is loaded in by the parent.

		swiperConfig : {
			numberOfSlides : 2,
			config         : {
				init            : true,
				initialSlide    : 0,
				slidesPerView   : document.body.clientWidth > 500 ? 'auto' : 1,
				speed           : 400,
				spaceBetween    : 0,
				resistanceRatio : 0,
				direction       : 'horizontal',
				threshold       : 50,
				simulateTouch	  : false,
			},
		},

		activeSlide : 0,
		confirm     : false,

	} ),

	watch : {

		state : {

			immediate : true,
			handler( state ) {
				if ( state === 'closed' ) {
					this.close();
					return;
				}

				this.open();
			}
		},

		activeSlide( activeSlide ) {

			if ( activeSlide === 0 ) {
				this.close();
			}

		},

	},

	methods : {
		open() {
			this.$nextTick( () => {
				this.activeSlide = 1;
			} );
			this.$emit( 'open' );
		},

		close() {
			this.activeSlide = 0;
			this.confirm = false;

			this.$emit( 'close' );
		},

		updateActiveSlide( swiper ) {
			this.activeSlide = swiper.activeIndex;
		},

		edit() {
			this.activeSlide = 0;
			this.$emit( 'edit' );
		},

		emitDelete() {
			this.$emit( 'delete' );
		},
	},

	components : {
		Swiper,
	}
};

</script>

<style lang="scss">
.side-sheet {

	.swipers {
		position: fixed;
		top: 0;
		left: 0;
		height: 100vh;
		width: 100vw;
		z-index: 100;
		pointer-events: none;

		&.active {
			pointer-events: all;

			.empty {
				opacity: 1 !important;
			}

			.swiper-slide:nth-child(2)  {
				box-shadow: $defaultBoxShadow;
			}
		}

		.swiper-wrapper .swiper-slide {

			&:not( :nth-child( 1 ) ) {
				width: 800px;
				max-width: 99.99vw;
				overflow-y: scroll;

				&::-webkit-scrollbar-track {
					background: white;
				}
			}

			> .empty {
				opacity: 0;
				width: 100vw;
				height: 100vh;
				background: $opaqueDarkBlue;
			}

			> .page {
				background: white;
				height: 100%;

				> .header {
					display: flex;
					justify-content: space-between;
					align-items: center;
					padding: 30px;

					.title-container {
						display: flex;
						flex-flow: row nowrap;
						align-items: center;
						justify-content: space-evenly;

						.box {
							width: 6px;
							height: 6px;
							background: $color-primary--variant-1;
							border-radius: 2px;
							margin-top: -2px;
						}

						h1 {
							font-family: 'Josefin Sans', sans-serif;
							font-size: 16px;
							letter-spacing: 0.15em;
							text-transform: uppercase;
							margin: 0 10px;
						}

						.title {
							color: $color-primary;
							margin-left: 0;
						}

						.status {
							color: $color-primary--variant-1;
							position: relative;
						}
					}

					.buttons-container {
						display: flex;
						flex-flow: row nowrap;
						align-items: center;

						.icon-pencil {
							font-size: 26px;
							margin-right: 16px;
							color: $color-primary;
						}

						.delete-button {
							background: $error;
							font-size: 14px;
							min-width: unset;
							padding: 10px 30px;
							margin-right: 10px;
						}

						.confirm,
						.cancel {
							display: flex;
							flex-flow: row;
							align-items: center;
							padding: 0 25px;
							align-self: stretch;
							transform: scale(1, 1);
							transition: transform 0.2s ease;
							cursor: pointer;

							&:active,
							&:focus {
								transform: scale(0.8, 0.8) !important;
							}

							p {
								color: $blueGrey;
							}

							.icon-check {
								position: relative;
								display: inline-block;
								transform: translateY( -5px );
								height: 30px;
								width: 30px;
								&::before {
									position: absolute;
									left: 0;
									top: 60%;
									height: 40%;
									width: 3px;
									background-color: green;
									content: "";
									transform: translateX( 15px ) rotate(-50deg);
									transform-origin: left bottom;
								}
								&::after {
									position: absolute;
									left: 0;
									bottom: 0;
									height: 3px;
									width: 70%;
									background-color: green;
									content: "";
									transform: translateX( 15px ) rotate( -50deg );
									transform-origin: left bottom;
								}
							}
						}
					}
				}

				> .full-page {
					background: inherit;
				}
			}
		}
	}
}

@media only screen and ( max-width: 640px ) {

	.side-sheet .icon-pencil {
		display: none;
	}
}
</style>
